import { useSession } from '../store/session'

// Mirrors the Go authorizer: an effective permission grants `action` when it equals the
// action exactly OR its base (text before the first ':') equals the action.
export function matchPermission(perms: string[], action: string): boolean {
  if (!action) return false
  for (const name of perms) {
    if (name === action) return true
    const base = name.includes(':') ? name.slice(0, name.indexOf(':')) : name
    if (base === action) return true
  }
  return false
}

export function useHasPermission(action: string): boolean {
  const me = useSession((s) => s.me)
  return !!me && matchPermission(me.permissions, action)
}

export function useHasRole(...roles: string[]): boolean {
  const me = useSession((s) => s.me)
  return !!me && me.roles.some((r) => roles.includes(r))
}

/** The single display role (the console assigns one role per user via the UI). */
export function usePrimaryRole(): string {
  const me = useSession((s) => s.me)
  return me?.roles[0] ?? ''
}
